import { Grid, Typography } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { NotificationType } from 'features/notifications/notifications.types';
import { PushNotificationPreview } from 'features/notifications/components/PushNotificationPreview';

type NameAndAddress = {
  name: string;
  address?: string | null;
};

type ReportNotificationPreviewProps = {
  geoEvent: NameAndAddress;
  supportsNotifications?: boolean;
};

const getNotificationTitle = (nameAndAddress: NameAndAddress): string => {
  if (nameAndAddress.address) {
    return `${nameAndAddress.name} - ${nameAndAddress.address}`;
  }

  return nameAndAddress.name;
};

export const ReportNotificationPreview = (
  props: ReportNotificationPreviewProps,
): JSX.Element | null => {
  const { geoEvent, supportsNotifications = true } = props;
  const { t } = useTranslation();
  const { messageText, notificationType } = useWatch();

  if (!supportsNotifications) {
    return (
      <Grid size={12}>
        <Typography align="center">
          {t('addIncidentReport.silentNotificationMessage.description')}
        </Typography>
      </Grid>
    );
  }

  if (notificationType !== NotificationType.Silent && Boolean(messageText)) {
    return (
      <Grid size={{ xs: 12, sm: 6 }}>
        <PushNotificationPreview
          isCritical={notificationType === NotificationType.Critical}
          title={getNotificationTitle(geoEvent)}
          body={messageText}
        />
      </Grid>
    );
  }

  if (notificationType === NotificationType.Silent) {
    return (
      <Grid size={12}>
        <Typography
          sx={{ fontWeight: (theme) => theme.typography.fontWeightMedium }}
          align="center"
        >
          {t('addIncidentReport.silentNotificationMessage.title')}
        </Typography>
        <Typography align="center">
          {t('addIncidentReport.silentNotificationMessage.description')}
        </Typography>
      </Grid>
    );
  }

  return null;
};
